import { Component, Input } from '@angular/core';
import { BtBarcodeModel } from '../bt-barcode.model';

@Component({
    selector: 'bt-barcode-design',
    templateUrl: './bt-barcode-design.component.html',
    styleUrls: ['./bt-barcode-design.component.scss']
})
export class BtBarcodeDesignComponent {
    @Input() model: BtBarcodeModel;
    @Input() value: any;
}